// Retention windows for high-volume tables. Single source of truth shared
// between user-facing UI handlers, the worker CRON, and the export dialog
// so the number can't drift across the three call sites.

// Days of per-message detail retention for api.communications. Older
// data is aggregated only (api.communication_stats_daily, retained
// indefinitely). Used by:
//   - src/api/user-billing-reports.ts: drill-down handler refuses
//     dates older than this and export auto-downgrades transactions
//     level to daily.
//   - src/components/ExportDialog.tsx: warning when range exceeds
//     retention.
//   - src/worker-entrypoint.ts: daily CRON purge_communications call.
// See Item 0.D in FUTURE-CHANGES.md for the rollout history.
export const COMMUNICATIONS_RETENTION_DAYS = 45;
